import StyleSelect from "../../components/Button/AutoComplete";
import tabletrans from "../../translate/tables";
import StyleDatePicker from "../../components/Button/DatePicker";

import { useEffect, useState } from "react";
import env from "../../env";

function VisitorFilter(props) {
  const categoryOptions = props.categoryOptions || [];
  const visitorOptions = props.visitorOptions || [];
  const token = props.token;

  const currentFilters = props.currentFilters || {};
  const onFilterChange = props.onFilterChange;

  const [userOptions, setUserOptions] = useState([]);
  const [userSearch, setUserSearch] = useState("");

  useEffect(() => {
    if (!userSearch || userSearch.length < 4) {
      setUserOptions([]);
      return;
    }

    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        customer: userSearch,
      }),
    };

    fetch(env.siteApi + "/panel/user/list-customers", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setUserOptions(result?.filter || []);
        },
        (error) => {
          console.log(error);
          setUserOptions([]);
        },
      );
  }, [userSearch, token]);

  const toArray = (value) => {
    if (!value) {
      return [];
    }

    return Array.isArray(value) ? value : [value];
  };

  const getId = (item) => {
    if (!item) {
      return "";
    }

    if (item.id !== undefined && item.id !== null) {
      return String(item.id);
    }

    if (item._id !== undefined && item._id !== null) {
      return String(item._id);
    }

    return "";
  };

  /**
   * =========================
   * فروش / خرید
   * =========================
   */
  const handlePurchaseChange = (value) => {
    onFilterChange?.({
      purchase: value?.id === "true",
    });
  };

  /**
   * =========================
   * ویزیتور
   * =========================
   */
  const handleVisitorChange = (items) => {
    const selectedItems = Array.isArray(items) ? items : items ? [items] : [];

    const selectedIds = selectedItems
      .map((item) => getId(item))
      .filter(Boolean);

    onFilterChange?.({
      manageIds: selectedIds,
    });
  };

  /**
   * =========================
   * دسته‌بندی
   * =========================
   */
  const handleCategoryChange = (items) => {
    const selectedItems = Array.isArray(items) ? items : items ? [items] : [];

    const selectedIds = selectedItems
      .map((item) => getId(item))
      .filter(Boolean);

    onFilterChange?.({
      category: selectedIds,
    });
  };

  /**
   * =========================
   * تاریخ
   * =========================
   */
  const formatApiDate = (date) => {
    if (!date) {
      return "";
    }

    const value = String(date).trim();
    const parts = value.split(",");

    if (parts.length === 3) {
      const [year, month, day] = parts;

      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0",
      )}`;
    }

    return value;
  };

  const handleDateChange = (date) => {
    onFilterChange?.({
      dateFrom: formatApiDate(date?.dateFrom),
      dateTo: formatApiDate(date?.dateTo),
    });
  };

  /**
   * =========================
   * Selected Visitors
   * =========================
   */
  const selectedVisitorIds = toArray(currentFilters.manageIds).map(String);

  const selectedVisitorOptions = visitorOptions.filter((item) => {
    const id = getId(item);

    return id && selectedVisitorIds.includes(id);
  });

  /**
   * =========================
   * Selected Categories
   * =========================
   */
  const selectedCategoryIds = toArray(currentFilters.category).map(String);

  const selectedCategoryOptions = categoryOptions.filter((item) => {
    const id = getId(item);

    return id && selectedCategoryIds.includes(id);
  });

  /**
   * =========================
   * Purchase
   * =========================
   *
   * false = فروش
   * true = خرید
   */
  const purchaseValue = currentFilters.purchase === true ? "true" : "false";

  const purchaseOptions = [
    {
      id: "false",
      title: "فروش",
    },
    {
      id: "true",
      title: "خرید",
    },
  ];

  const selectedPurchaseOption = purchaseOptions.find(
    (item) => item.id === purchaseValue,
  );

  return (
    <div
      className="user-filter d-filter"
      style={{
        backgroundColor: "#fff",
        marginBottom: "1rem",
      }}
    >
      <div className="serach-input">
        {/* ================= فروش / خرید ================= */}
        <StyleSelect
          key={`purchase-${purchaseValue}`}
          title="نوع معامله"
          direction={props.lang.dir}
          options={purchaseOptions}
          label="title"
          action={handlePurchaseChange}
          multiSelect={false}
          defaultValue={selectedPurchaseOption}
        />

        {/* ================= ویزیتور ================= */}
        <StyleSelect
          key={`visitor-${selectedVisitorIds.join("-")}`}
          title="کاربر"
          direction={props.lang.dir}
          options={visitorOptions}
          label="title"
          action={handleVisitorChange}
          multiSelect={true}
          defaultValue={selectedVisitorOptions}
        />

        {/* ================= دسته‌بندی ================= */}
        <StyleSelect
          key={`category-${selectedCategoryIds.join("-")}`}
          title="دسته‌بندی"
          direction={props.lang.dir}
          options={categoryOptions}
          label="title"
          action={handleCategoryChange}
          multiSelect={true}
          defaultValue={selectedCategoryOptions}
        />

        {/* ================= تاریخ ================= */}
        <StyleDatePicker
          title={tabletrans.selectDate[props.lang.lang]}
          class="filterComponent"
          direction={props.lang.dir}
          local={props.lang.dir === "ltr" ? "en" : "fa"}
          action={handleDateChange}
        />
      </div>
    </div>
  );
}

export default VisitorFilter;
